import {
  useTheme,
  Box,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Close as CloseIcon,
} from '@mui/icons-material';

import { useCommonStyles, items } from "./common";

const Mobile = (props) => {
  const { lang = '', switchLang = () => {} } = props;

  const style = useCommonStyles(useTheme());
  const { flag: flagStyle } = style;
  const enStyle = lang === 'en' ? style.flagEN : {};
  const langLabel = lang === 'en' ? 'Srpski' : 'English';
  const langIcon = (
    <Box
      sx={{ ...flagStyle, ...enStyle }}
    />
  );

  const goto = key => {
    window.open(items[key].href, '_blank');
  };

  return (
    <Box sx={{ display: { sm: 'none', xs: 'flex' }, flexGrow: 1 }}>
      <SpeedDial
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        ariaLabel="Glavni Meni"
        FabProps={{ sx: style.mobileFab }}
        icon={
          <SpeedDialIcon
            icon={<MenuIcon />}
            openIcon={<CloseIcon />}
          />
        }
      >
        {Object.keys(items).map(key => (
          <SpeedDialAction
            key={`speed-dial-action-${key}`}
            icon={items[key].icon}
            tooltipTitle={key}
            FabProps={{ sx: style.mobileFab }}
            onClick={() => goto(key)}
          />
        ))}
        <SpeedDialAction
          tooltipTitle={langLabel}
          onClick={() => switchLang()}
          FabProps={{ sx: style.mobileFab }}
          icon={langIcon}
        />
      </SpeedDial>
    </Box>
  );
};

export default Mobile;
